<mat-icon class="float-right rounded pt-2 pb-2 pl-3 pr-3 botonesCerrar" mat-button mat-dialog-close> cancel_presentation</mat-icon>
<section class="container">
    <div class="row">
        <div class="col-12 mt-5">
            <full-calendar [options]="calendarOptions"></full-calendar>
        </div>
    </div>
</section>